import { TableColumnsType } from "antd";
import { displayPercent, formatPoint } from "app/shared/util/percent";
import * as _ from 'lodash';

export const plusPoints = [
    {
        name: "Thành tích vượt trội/ đóng góp nổi bật trong năm vào thành quả chung của Công ty, Tập đoàn",
    },
    {
        name: "Sáng kiến cải tiến giúp nâng cao hiệu quả trong quản lý, vận hành được áp dụng và đem lại hiệu quả vượt bậc được cấp có thẩm quyền của Công ty, Tập đoàn công nhận",
    },
    {
        name: "Thành tích khác theo giải trình của đơn vị và đã được cấp có thẩm quyền phê duyệt",
    }
]

export const minusPoints = [
    {
        name: "Để xảy ra các tồn tại nghiêm trọng, kéo dài mà không được xử lý dứt điểm"
    },
    {
        name: "Mắc lỗi làm ảnh hưởng nghiêm trọng tới hoạt động của Công ty",
    },
    {
        name: "Các vi phạm nghiêm trọng khác bị cảnh báo, nhắc nhở",
    },
]

export const columnsResult: TableColumnsType<any> = [
    {
        key: 'name',
        dataIndex: 'name',
        width: 200,
    },
    {
        title: 'Số KR',
        key: 'krCounting',
        align: 'center',
        dataIndex: 'krCounting',
    },
    {
        title: 'Tỷ lệ',
        key: 'krCountingProportion',
        align: 'center',
        dataIndex: 'krCountingProportion',
        render: item => item ? `${formatPoint(item)}%` : undefined,
    },
];

export const columnsResultComplete: TableColumnsType<any> = [
    {
        title: 'Bên được đánh giá',
        key: 'ownerName',
        dataIndex: 'ownerName',
        width: 300,
    },
];
